// Шина глобальных событий с интерфейсом $on/$off/$emit (доступна как this.$bus).
export class EventBus {
  constructor() {
    this.handlers = new Map(); // имя события -> Set<обработчик>
  }

  $on(event, fn) {
    if (!this.handlers.has(event)) this.handlers.set(event, new Set());
    this.handlers.get(event).add(fn);
  }

  $off(event, fn) {
    if (!fn) {
      this.handlers.delete(event);
      return;
    }
    this.handlers.get(event)?.delete(fn);
  }

  $emit(event, ...args) {
    // копия перед перебором: обработчик может отписать себя ($off) во время вызова;
    // try/catch: исключение в одном обработчике не должно ломать остальные и вызвавший $emit код
    [...(this.handlers.get(event) ?? [])].forEach((fn) => {
      try {
        fn(...args);
      } catch (e) {
        console.error(`[eventBus] ошибка в обработчике '${event}':`, e);
      }
    });
  }
}

export const bus = new EventBus();
